import { render } from "./ProdutoCompleto.vue?vue&type=template&id=a578f772&scoped=true"
import script from "./ProdutoCompleto.vue?vue&type=script&lang=js"
export * from "./ProdutoCompleto.vue?vue&type=script&lang=js"

import "./ProdutoCompleto.vue?vue&type=style&index=0&id=a578f772&lang=scss"
import "./ProdutoCompleto.vue?vue&type=style&index=1&id=a578f772&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a578f772"]])

export default __exports__